import React from 'react';
import { Link } from 'react-router-dom';
import { FaGlobeAsia, FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const countries = ['UAE', 'Saudi Arabia', 'Kuwait', 'Qatar', 'Bahrain', 'Oman', 'Singapore', 'Malaysia', 'Libya'];

const Footer = () => (
  <footer className="footer">
    <div className="footer-top">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="brand-logo">
              <div className="brand-icon-f"><FaGlobeAsia /></div>
              <div>
                <div className="footer-brand-name">Pavishna</div>
                <div className="footer-brand-sub">Global Services</div>
              </div>
            </div>
            <p className="footer-desc">Your trusted gateway to international career opportunities. We connect skilled professionals with top employers across the Gulf and beyond.</p>
            <div className="social-links">
              <a href="https://www.pavishnagroups.com" target="_blank" rel="noreferrer" className="social-link"><FaFacebook /></a>
              <a href="https://www.pavishnagroups.com" target="_blank" rel="noreferrer" className="social-link"><FaInstagram /></a>
              <a href="https://www.pavishnagroups.com" target="_blank" rel="noreferrer" className="social-link"><FaLinkedin /></a>
              <a href="tel:+919876543210" className="social-link"><FaWhatsapp /></a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/jobs">Browse Jobs</Link></li>
              <li><Link to="/jobs-served">Jobs Served</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/register">Register</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Countries We Serve</h4>
            <ul className="footer-links">
              {countries.map(c => <li key={c}><span className="country-dot">🌍</span>{c}</li>)}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact Info</h4>
            <ul className="footer-contact">
              <li><FaMapMarkerAlt /><span>Visit our official website: <a href="https://www.pavishnagroups.com" target="_blank" rel="noreferrer">pavishnagroups.com</a></span></li>
              <li><FaPhone /><span> +91 +91 91501 26022 </span></li>
              <li><span> +91 89252 33328 </span></li>
              <li><FaEnvelope /><span>info@pavishnagroups.com</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="container">
        <p>© {new Date().getFullYear()} Pavishna Global Services. All rights reserved.</p>
        <p>Empowering careers across the globe 🌐</p>
      </div>
    </div>
  </footer>
);

export default Footer;
